<ng-container [ngSwitch]="routeData?.role">

  <flexi-compliance-list *ngSwitchCase="'list'"></flexi-compliance-list>

  <flexi-compliance-rating
    *ngSwitchCase="'csm'"
    [aggregate]="routeData.aggregate!">
  </flexi-compliance-rating>

  <flexi-compliance-final-view
    *ngSwitchCase="'customer'"
    [aggregate]="routeData.aggregate!"
    [asPublishedResult]="true">
  </flexi-compliance-final-view>

  <!-- An archived review is an immutable snapshot: even a CSM gets the
       read-only view, which is the same rendering the customer sees. -->
  <flexi-compliance-final-view
    *ngSwitchCase="'archived'"
    [aggregate]="routeData.aggregate!">
  </flexi-compliance-final-view>

  <div *ngSwitchCase="'locked'" class="fcomp-shell">
    <div class="fcomp-banner fcomp-banner--warning">
      <i class="pi pi-lock"></i>
      <div>{{ 'FLEXI_COMPLIANCE.LOCKED_BANNER' | translate }}</div>
    </div>
  </div>

</ng-container>
